import { render, staticRenderFns } from "./picture_manage.vue?vue&type=template&id=468fa590&scoped=true&"
import script from "./picture_manage.vue?vue&type=script&lang=js&"
export * from "./picture_manage.vue?vue&type=script&lang=js&"
import style0 from "./picture_manage.vue?vue&type=style&index=0&id=468fa590&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468fa590",
  null
  
)

export default component.exports